
export default function dateProps(onClick) {
  return ({
    months: 'JAN,FEB,MAR,APR,MAY,JUN,JUL,AUG,SEP,OCT,NOV,DEC'.split(','),
    weekdaysShort: 'SMTWtFs'.split(''),
    firstDayOfWeek: 1,
    toMonth: new Date(),
    onDayClick: onClick,
  });
}
